export default __webpack_public_path__ + "static/media/SpaceMono-Regular.8dc9dfb5.ttf";